import { Progress } from 'antd';

import { $ArithmeticOperation, GymMode } from '@suntex.fim/enums';
import { Tooltip } from '@suntex.fim/ui';
import { GymGameNumber, gymGameSubtitle } from '@suntex.fim/utils';

import { ArithmeticOperationSlug } from '../../src/utils/gyms';

const PROGRESS_SIZE = 24;
const FULL_PROGRESS = 100;

/**
 * Renders a gym table cell with progress steps.
 */
export function GymTableCell({
  steps,
  opSlug,
  rowId,
  infoValue,
  level,
  graphColor,
}: {
  steps: number;
  opSlug: ArithmeticOperationSlug;
  rowId: string | number;
  infoValue: { [key: string]: boolean };
  level: GymMode;
  graphColor: string;
}) {
  const op = $ArithmeticOperation.fromSlug(opSlug);
  return (
    <div
      className="gym-table-cell"
      style={{
        overflow: 'hidden',
        display: 'grid',
        gridGap: '2px',
        gridTemplateColumns: `repeat(${steps}, minmax(12px, 1fr))`,
      }}
    >
      {Array.from({ length: steps }).map((_, i) => {
        const gameNumber = (i + 1) as GymGameNumber;
        const stepKey = `${opSlug}-${rowId}-step${gameNumber}`;
        const isCompleted = infoValue[gameNumber];
        return (
          <Tooltip
            classNames={{ root: 'progress-tooltip' }}
            placement="right"
            arrow={false}
            key={stepKey}
            title={
              <div>
                <div>
                  {gymGameSubtitle(level, op, gameNumber)} is{' '}
                  <b>{isCompleted ? 'completed' : 'incomplete'}</b>
                </div>
              </div>
            }
          >
            <div
              role="progressbar"
              aria-label={
                gymGameSubtitle(level, op, gameNumber) +
                (isCompleted ? ' completed' : ' incomplete')
              }
              aria-valuemin={0}
              aria-valuemax={FULL_PROGRESS}
              aria-valuenow={isCompleted ? FULL_PROGRESS : 0}
              tabIndex={0}
            >
              <Progress
                strokeColor={graphColor}
                percent={isCompleted ? FULL_PROGRESS : 0}
                showInfo={false}
                size={['100%', PROGRESS_SIZE]}
                className="custom-step-progress"
              />
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}
